import Document from 'src/components/docs/Document';

const Inference: React.FC = () => {
    const list = [
        { label: 'v3.0', value: 'v3.0' },
        { label: 'master', value: 'master' },
        { label: 'v2.6', value: 'v2.6' },
        { label: 'v2.5', value: 'v2.5' },
        { label: 'v2.4', value: 'v2.4' },
        { label: 'v2.3', value: 'v2.3' },
        { label: 'v2.2', value: 'v2.2' },
        { label: 'v2.1', value: 'v2.1' },
        { label: 'v2.0', value: 'v2.0' },
        { label: 'v1.8', value: 'v1.8' }
    ];
    const defaultVersionValue = 'v3.0';

    return <Document {...{ list, defaultVersionValue, isPage: false }} />;
};

export default Inference;
